new Swiper('.image-sliders', {
  slidesPerView: 'auto',
  spaceBetween: 20,
  loop: true,
  loopAdditionalSlides: 10,

  speed: 4000, // higher = slower continuous motion

  autoplay: {
    delay: 0,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
  },

  freeMode: {
    enabled: true,
    momentum: false,
  },

  grabCursor: true,
  allowTouchMove: true,

  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  breakpoints: {
    0: {
      slidesPerView: 1.5,
    },
    580: {
      slidesPerView: 2.5,
    },
    776: {
      slidesPerView: 3.5,
    },
    1024: {
      slidesPerView: 3.5,
    },
    1400: {
      slidesPerView: 5.5,
    },
  },
});
